import React, {ReactElement} from 'react';
import Header from '../../components/page/header/header';
import Footer from '../../components/page/footer/footer';
import Breadcrumbs from '../../components/page/breadcrumbs/breadcrumbs';
import Privacy from '../../components/privacy/privacy';
import ModalContainer from '../../components/page/modal-container/modal-container';
import {Helmet} from 'react-helmet-async';
import Title from '../../components/page/head/title/title';
import {CanonicalUrl, PageTitle} from '../../const/seo';

export default function PrivacyScreen(): ReactElement {
  return (
    <>
      <Helmet>
        <title>{PageTitle.Privacy}</title>
        <link rel="canonical" href={CanonicalUrl.Privacy}/>
      </Helmet>
      <Header/>
      <Breadcrumbs
        firstPage={'Политика конфиденциальности'}
      />
      <Privacy/>
      <Footer/>
      <ModalContainer />
    </>
  );
}
